import React from "react";
import styled from "styled-components";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { colors } from "./colors";
import { formatCompact, formatDay, formatSignedPercent, pctChange } from "./format";
import { Part, PartTitle, PartNote } from "./Part";

export default function RankShiftChart({ buckets, baselineStart }) {
    const top3 = buckets[0];
    const top3Change = top3 ? pctChange(top3.before, top3.after) : 0;

    return (
        <Part>
            <PartTitle>Keyword ranking distribution</PartTitle>
            <PartNote>Top-3 keywords <Bad>{formatSignedPercent(top3Change)}</Bad> · rankings pushed to page 2+</PartNote>
            <Plot role="img" aria-label="Number of ranking keywords by position bucket, before and after the drop">
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={buckets} margin={{ top: 4, right: 0, left: -8, bottom: 0 }} barGap={3} barCategoryGap="26%">
                        <CartesianGrid vertical={false} stroke={colors.line} />
                        <XAxis dataKey="bucket" tickLine={false} axisLine={false} tick={{ fontSize: 11, fill: colors.muted }} />
                        <YAxis tickLine={false} axisLine={false} tick={{ fontSize: 11, fill: colors.chartSubtle }} tickFormatter={formatCompact} width={40} />
                        <Tooltip cursor={{ fill: colors.canvas }}
                                 contentStyle={{ borderRadius: 8, border: `1px solid ${colors.line}`, fontSize: 12, boxShadow: "0 4px 12px rgba(15,20,25,0.08)" }}
                                 labelFormatter={(label) => `Position ${label}`}
                                 formatter={(value, name) => [formatCompact(Number(value)), name === "before" ? "Before" : "Now"]} />
                        <Bar dataKey="before" fill={colors.lineStrong} radius={[3, 3, 0, 0]} isAnimationActive={false} />
                        <Bar dataKey="after" fill={colors.accent} radius={[3, 3, 0, 0]} isAnimationActive={false} />
                    </BarChart>
                </ResponsiveContainer>
            </Plot>
            <Legend>
                <span><Swatch $color={colors.lineStrong} />Week of {formatDay(baselineStart)}</span>
                <span><Swatch $color={colors.accent} />Last 7 days</span>
            </Legend>
        </Part>
    );
}

const Bad = styled.span`
    font-weight: 500;
    color: ${colors.criticalInk};
`;

const Plot = styled.div`
    height: 168px;
    margin-top: 12px;
`;

const Legend = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 8px;
    font-size: 12px;
    color: ${colors.muted};
    span { display: flex; align-items: center; gap: 6px; }
`;

const Swatch = styled.span`
    width: 10px;
    height: 10px;
    border-radius: 2px;
    background: ${({ $color }) => $color};
`;
